// We just default to staging by default
export var isDevelopment = function () { return !isStaging() && !isProduction(); };
// We use the same environment for development and staging
// But we still need a switch to only show dev features locally
export var isStaging = function () {
    return process.env.REACT_APP_VERCEL_GIT_COMMIT_REF === "staging";
};
export var isProduction = function () {
    return process.env.REACT_APP_VERCEL_GIT_COMMIT_REF === "master";
};
export var getNodeURI = function () {
    return isDevelopment()
        ? process.env.REACT_APP_TESTNET_URI
        : process.env.REACT_APP_MAINNET_URI;
};
export var getSubgraphqlURI = function () {
    return (isDevelopment()
        ? process.env.REACT_APP_KOVAN_SUBGRAPHQL_URL
        : process.env.REACT_APP_SUBGRAPHQL_URL) ||
        "https://api.thegraph.com/subgraphs/name/kenchangh/ribbon-finance-kovan";
};
export var getV2SubgraphURI = function () {
    return (isDevelopment()
        ? process.env.REACT_APP_KOVAN_V2_SUBGRAPHQL_URL
        : process.env.REACT_APP_V2_SUBGRAPHQL_URL) ||
        "https://api.thegraph.com/subgraphs/name/ribbon-finance/ribbon-v2-kovan";
};
export var getDefaultNetworkName = function () {
    return isDevelopment() ? "kovan" : "mainnet";
};
export var getDefaultChainID = function () { return (isDevelopment() ? 42 : 1); };
//# sourceMappingURL=env.js.map